import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import { StudentAppI18nEn } from './modules';
import { CommonI18nEn, AssessmentI18nEn } from '@greatmindsorg/assess-web-core-lib';
import { InsyncI18N } from '@insync-students-locales/en';
const insyncStudent = {
  'insync-app': InsyncI18N
};
export default function initI18n() {
  const resources = {
    en: {
      ...CommonI18nEn,
      ...StudentAppI18nEn,
      ...AssessmentI18nEn,
      ...insyncStudent
    }
  };
  i18n.use(initReactI18next).init({
    ns: ['common', 'studentApp', 'insync-app'],
    defaultNS: 'studentApp',
    debug: false,
    resources,
    fallbackLng: 'en',
    lng: 'en',
    interpolation: {
      escapeValue: false
    }
  });
}